import { List, Record } from 'immutable';
import find from 'lodash/find';
const RegvarModelRecord = Record({
    value: null,
    include: true,
    $extra: null,
    $errors: List(),
    $rcc: null,
    $isDirty: false,
    $temp: null
});
export class RegvarModel extends RegvarModelRecord {
    constructor(values){
        values ? super(values) : super();
        if (new.target === RegvarModel) {
            throw new Error('RegvarModel is abstract.');
        }
    }
    setInclude(value, options) {
        let result = this.set('include', value);
        if (options?.washField) {
            result = result.set('$isDirty', false);
        }
        if (options?.markAsDirty) {
            result = result.set('$isDirty', true);
        }
        return result;
    }
    getValue() {
        return this.value;
    }
    setValue(value, options) {
        let result = this.set('value', value);
        if (options?.washField) {
            result = result.set('$isDirty', false);
        }
        if (options?.markAsDirty) {
            result = result.set('$isDirty', true);
        }
        return result;
    }
    errorsOutOfSync(errors) {
        const curErrors = this.$errors;
        // Kassa immutable-bindings - err kan inte vara undefined, se https://github.com/immutable-js/immutable-js/issues/1246
        return curErrors.count() !== errors.length || curErrors.some((err)=>!find(errors, (e)=>e.isFatal === err.isFatal && e.message === err.message && e.rule === err.rule));
    }
    setValidationErrors(errors) {
        if (this.errorsOutOfSync(errors)) {
            return this.set('$errors', List(errors));
        }
        return this;
    }
    getValidationErrors() {
        return this.get('$errors');
    }
    toIncaJS() {
        return {
            ...this.$extra,
            value: this.value,
            include: this.include
        };
    }
}
